import React from 'react';
import { DebugMessage } from '../SandBox.types';
import _ from 'lodash';

interface ResponseLogProps {
  messages?: DebugMessage[];
}

const ResponseLog = ({ messages }: ResponseLogProps) => {
  if (_.isNil(messages) || _.isEmpty(messages)) {
    return <div>No message Logs available</div>;
  }

  return (
    <div>
      {_.sortBy(messages, 't')
        .reverse()
        .map((message, index) => {
          const date = message.t ? new Date(message.t) : null;
          return (
            <div key={index} className="sandbox-response-log-message mb-3">
              <code className={'text-black'} style={{ wordBreak: 'break-all' }}>
                <span className={'text-muted mr-2'}>{date ? date.toISOString() : 'Unknown date'}:</span> {message.m}
              </code>
            </div>
          );
        })}
    </div>
  );
};

export default ResponseLog;
